export interface ProjectUserI {
  userId: number;
  role: string;
}

export interface DocumentI {
  content: string;
  summary: string;
  projectId: string;
  id: string;
  created: number;
  name: string;
  contentType: string;
  url: string;
  processed: boolean;
  error: string | null;
}

export interface DocumentPaginationI {
  total: number;
  data: DocumentI[];
  perPage: number;
  page: number;
  totalPages: number;
}

export interface ProjectI {
  id: string;
  title: string;
  description: string;
  fontAwesomeIcon: string;
  tailwindColor: string;
  users: ProjectUserI[];
  created: number;
  updated: number;
}

export interface ProjectPaginationI {
  total: number;
  data: ProjectI[];
  perPage: number;
  page: number;
  totalPages: number;
}

export interface ProjectsResultI {
  data: ProjectI[];
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface ProjectsStateI {
  projects: ProjectI[];
  projectsResult: ProjectsResultI
  project: ProjectI;
  documents: DocumentPaginationI;
  projectPagination: ProjectPaginationI;
}

export const state: ProjectsStateI = {
  projects: [],
  projectsResult: {
    data: [],
    page: 1,
    perPage: 0,
    total: 0,
    totalPages: 0,
  },
  project: {
    id: '',
    title: '',
    description: '',
    fontAwesomeIcon: '',
    tailwindColor: '',
    users: [],
    created: 0,
    updated: 0,
  },
  documents: {
    total: 0,
    data: [],
    perPage: 0,
    page: 1,
    totalPages: 0,
  },
  projectPagination: {
    total: 0,
    data: [],
    perPage: 0,
    page: 1,
    totalPages: 0,
  },
};
